import { AppStateHistory, T } from 'types';

export const downloadUrl = (url: string): void => {
  window.open(url, 'Download');
};

export const hasDocumentStateError = (state: AppStateHistory): boolean => {
  const { status } = state || {};

  return status === 'WITH_KNOWN_ERROR' || status === 'WITH_UNKNOWN_ERROR';
};

export const getDocumentStateLabel = (state: AppStateHistory, t: T): string => {
  const { status, type } = state || {};

  return `${t(type)} > ${t(status)}`;
};
